import {updateScroll} from '../utilities/locootiveScroll';
import barba from '@barba/core';

const burger = {
    btn: $('.c-burgerMenu'),
    topBar: $('.c-burgerMenu span:nth-child(1)'),
    middleBar: $('.c-burgerMenu span:nth-child(2)'),
    bottomBar: $('.c-burgerMenu span:nth-child(3)'),
    navbar: $('.c-navbar__nav'),
    items: $('.c-navbar__nav ul li')
}

function openBurger(topBar, middleBar, bottomBar, navbar, items) {
    TweenMax.to(topBar, .3, {
        y: 12,
        ease: Power4.easeInOut,
    });
    TweenMax.to(bottomBar, .3, {
        y: -12,
        ease: Power4.easeInOut,
    });

    TweenMax.to(topBar, .3, {
        rotation: 45,
        ease: Power4.easeInOut,
        delay: .3
    });
    TweenMax.to(middleBar, .3, {
        opacity: 0,
        ease: Power4.easeInOut,
        delay: .3
    });
    TweenMax.to(bottomBar, .3, {
        rotation: -45,
        ease: Power4.easeInOut,
        delay: .3
    });

    TweenMax.to(navbar, 1, {
        scaleY: 1,
        transformOrigin: 'top',
        ease: Power4.easeInOut,
    });

    //  TweenMax.stagger

    TweenMax.to(items, .3, {
        opacity: 1,
        ease: Power4.easeInOut,
        delay: .75,
        //stagger: {
        //     from: "top",
        //     amount: .3
        // }
    });
}

function closeBurger(topBar, middleBar, bottomBar, navbar, items) {
    TweenMax.to(topBar, .3, {
        rotation: 0,
        ease: Power4.easeInOut,
    });

    TweenMax.to(middleBar, .3, {
        opacity: 1,
        ease: Power4.easeInOut,
        delay: .15
    });
    TweenMax.to(bottomBar, .3, {
        rotation: 0,
        ease: Power4.easeInOut,
    });

    TweenMax.to(topBar, .3, {
        y: 0,
        ease: Power4.easeInOut,
        delay: .3
    });
    TweenMax.to(bottomBar, .3, {
        y: 0,
        ease: Power4.easeInOut,
        delay: .3
    });

    TweenMax.to(navbar, 1, {
        scaleY: 0,
        transformOrigin: 'bottom',
        ease: Power4.easeInOut,
        delay: .6
    });

    TweenMax.to(items, .3, {
        opacity: 0,
        ease: Power4.easeInOut,
    });

}


// method that will update the active class on the menu, based on a given url
function updateMenu(url) {
    const active = document.querySelector('.menu a.active');

    if (active !== null) {
        active.classList.remove('active');
    }

    const links = Array.from(document.querySelectorAll('.menu a'));

    const index = links.map(link => link.href).findIndex((href) => {
        return url.indexOf(href) !== -1;
    });

    if (index !== -1) {
        links[index].classList.add('active');
    }
}

// hooks that will be triggered before any page transition
// meaning your menu active class will be updated before going to the next page
barba.hooks.before((data) => {
    updateMenu(data.trigger.href);
});


barba.hooks.before(() => {

    if ($('.c-burgerMenu').hasClass('js-isActive')) {
        setTimeout(function () {
            TweenMax.to(burger.topBar, 0, {rotation: 0, y: 0});
            TweenMax.to(burger.middleBar, 0, {opacity: 1,});
            TweenMax.to(burger.bottomBar, 0, {rotation: 0, y: 0});
            TweenMax.to(burger.navbar, 0, {scaleY: 0, delay: .5});
            TweenMax.to(burger.items, .3, {opacity: 0});
        }, 0)
    }
    $('.c-burgerMenu').removeClass('js-isActive');

});

burger.btn.click(function () {
    if ($(this).hasClass('js-isActive')) {
        closeBurger(burger.topBar, burger.middleBar, burger.bottomBar, burger.navbar, burger.items);
        $(this).removeClass('js-isActive');
    } else {
        openBurger(burger.topBar, burger.middleBar, burger.bottomBar, burger.navbar, burger.items);
        $(this).addClass('js-isActive');
    }
});
